/* eslint-disable react-hooks/exhaustive-deps */
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Grid,
} from "@mui/material";
// import ClearIcon from "@mui/icons-material/Clear";

import { ModalTransition } from "../shared/Dialog/Config";
import SingleLineDiagram from "./SingleLineDiagram";

const SingleLineDiagramDialog = ({ open, onClose, substationId }) => {
  if (!substationId) return null;

  return (
    <Dialog
      open={open}
      TransitionComponent={ModalTransition}
      keepMounted
      onClose={onClose}
      maxWidth={"xl"}
      className="dialog-wrapper"
    >
      <DialogContent className="dialog-line">
        <Grid container>
          {/* <Grid item xs={12} md={12}>
            <IconButton onClick={onClose}>
              <ClearIcon />
            </IconButton>
          </Grid> */}
          <Grid item xs={12} md={12}>
            <SingleLineDiagram substationId={substationId} />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions className="buttons-wrapper">
        <Button variant="outlined" size="large" onClick={onClose}>
          بستن
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SingleLineDiagramDialog;
